import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

interface ICurrencyData {
  id: string,
  name: string,
  size: number,
  displayName: string,
  abbreviation: string,
}

interface ITotalSizeObject {
  [currencyId: string]: ICurrencyData,
}

export const TotalSize = ({ row: { totalSize } }: { row: IDealCellData }) => {
  if (typeof totalSize === 'string') {
    return (
      <Tooltip content={ totalSize }>
        <span>{ totalSize }</span>
      </Tooltip>
    );
  }

  if (typeof totalSize === 'object' && totalSize !== null) {
    const totalSizeObj = totalSize as ITotalSizeObject;
    const currencyKeys = Object.keys(totalSizeObj);

    if (currencyKeys.length > 1) {
      return <span>-</span>;
    }

    if (currencyKeys.length === 1) {
      const currencyId = currencyKeys[0];
      const currency = totalSizeObj[currencyId];

      if (currency && typeof currency.size === 'number') {
        const formattedSize = formatNumberWithDecimals(currency.size, 0);
        const displayText = `${ currency.abbreviation }${ formattedSize }`;
        const tooltipText = `${ currency.name } ${ currency.size }`;

        return (
          <Tooltip content={ tooltipText }>
            <span>{ displayText }</span>
          </Tooltip>
        );
      }
    }
  }

  return <span>-</span>;
};

export default TotalSize;
